export const TYPE_META = {
  grafana: { label: "GRAFANA", color: "#F46800" },
  exor: { label: "EXOR RUNTIME", color: "#0D5C75" },
  scada: { label: "REMOTE SCADA", color: "#6366F1" },
  other: { label: "CUSTOM", color: "#475569" },
};

export const CARD_TYPES = Object.keys(TYPE_META);
